import React from 'react';
import { NavLink, Link } from 'react-router-dom';  // ⬅️ беремо NavLink
import '../styles/components/Header.css';
import '../styles/components/HeaderMobile.css';
import IconPng from '../components/IconPng';
import HeaderMobile from './HeaderMobile';

import logoTop from '../img/logo/logo-top.png';
import logoBottom from '../img/logo/logo-bottom.png';

const NAV = [
  { label: 'ABOUT US', href: '/about' },
  // { label: 'HOW IT WORKS', href: '/how' },
  { label: 'SERVICES', href: '/services' },
  { label: 'CASES', href: '/cases' },
  { label: 'CONTACTS', href: '/contacts' },
  { label: 'FAQ', href: '/faq' },
  //{ label: 'SHOWCASE', href: '/showcase' }
];

// у Header.jsx, над return
const handleNavClick = (href) => () => {
  if (href === '/cases') {
    // миттєво — до переходу
    window.scrollTo(0, 0);
    // на всяк випадок — після навігації:
    setTimeout(() => window.scrollTo(0, 0), 0);
  }
};


const SOCIAL = [
  // { name: 'X', href: 'https://x.com/your' },
  // { name: 'Telegram', href: 'https://t.me/your' },
  { name: 'LinkedIn', href: 'https://www.linkedin.com/company/intelligent-writing/' },
];

export default function Header() {
  return (
    <>
      {/* Мобільний хедер */}
      <div className="mobile-header-wrapper">
        <HeaderMobile />
      </div>

      {/* Десктопний сайдбар */}
      <aside className="sidebar">
        <div className="brand">
          <Link to="/" className="logo-stack" role="img" aria-label="Intelligent Writing logo">
            <img className="logo-part top" src={logoTop} alt="" aria-hidden="true" />
            <img className="logo-part bottom" src={logoBottom} alt="" aria-hidden="true" />
          </Link>
        </div>

        <nav className="nav">
          {NAV.map((item) => (
            <NavLink
              key={item.label}
              to={item.href}
              className={({ isActive }) => `nav-link${isActive ? ' is-active' : ''}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="spacer" />

        <div className="socials">
          {SOCIAL.map((s) => (
            <a
              key={s.name}
              className="soc"
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.name}
            >
              <IconPng name={s.name} size={48} />
            </a>
          ))}
        </div>
      </aside>
    </>
  );
}
